import React from "react";
import { FaUserAlt, FaLock, FaPhone, FaHome } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import "./style.scss";
import { registerUser } from "services/user/userService";
import Swal from "sweetalert2";
import { BiSolidErrorCircle } from "react-icons/bi";
import { PacmanLoader } from "react-spinners";

const RegisterForm = () => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [showMessage, setShowMessage] = useState(false);

  const handleFocus = () => {
    setShowMessage(true); // Hiển thị thông báo
    // setTimeout(() => {
    //   setShowMessage(false); // Ẩn thông báo sau 5 giây
    // }, 5000);
  };
  const handleBlur = () => {
    setShowMessage(false); // Tắt thông báo khi unfocus
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (phone.length !== 10) {
      setError("Số điện thoại phải bao gồm 10 chữ số");
      return;
    }

    if (password.length < 6 || password.length > 20) {
      setError("Mật khẩu phải từ 6 đến 20 ký tự.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Mật khẩu không khớp!");
      return;
    }

    try {
      setIsLoading(true);
      const response = await registerUser(fullName, email, phone, password);
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Đăng ký thành công!",
          text: "Mời bạn kiểm tra email để xác thực tài khoản!",
          timer: 5000,
          timerProgressBar: true,
          showConfirmButton: false,
          customClass: {
            popup: "my-swal", // Liên kết với lớp CSS
          },
        }).then(() => {
          navigate("/login");
        });
      }
    } catch (err) {
      if (err.response?.data?.message === "Existed email!") {
        setError("Email này đã đăng ký tài khoản!");
      } else if (err.response?.data?.message === "Existed phone number!") {
        setError("Số điện thoại này đã đăng ký tài khoản!");
      } else {
        setError(err.response?.data?.message || "Đăng ký thất bại");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="helo">
      <div className="register-form">
        <form onSubmit={handleSubmit}>
          <h1>Đăng kí</h1>

          <div className="input-box">
            <input
              type="text"
              placeholder="Họ tên"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              required
            />
            <FaUserAlt className="icon" />
          </div>

          <div className="input-box">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <MdEmail className="icon" />
          </div>
          {showMessage && (
            <div className="message-signin">Bạn chỉ được nhập 10 số</div>
          )}
          <div className="input-box">
            <input
              type="text"
              placeholder="Số điện thoại"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
              onFocus={handleFocus}
              onBlur={handleBlur}
              minLength="10"
              maxLength="10"
              pattern="\d{10}" // Đảm bảo chỉ nhận các ký tự số
            />
            <FaPhone className="icon" />
          </div>

          <div className="input-box">
            <input
              type="password"
              placeholder="Mật khẩu"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength="6"
              maxLength="20"
            />
            <FaLock className="icon" />
          </div>

          <div className="input-box">
            <input
              type="password"
              placeholder="Nhập lại mật khẩu"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength="6"
              maxLength="20"
            />
            <FaLock className="icon" />
          </div>

          {error && (
            <div className="error-message-dki">
              <span className="error-icon">
                <BiSolidErrorCircle />
              </span>{" "}
              <span>{error}</span>
            </div>
          )}

          <button className="register" type="submit">
            Đăng kí{" "}
          </button>
          <div className="register-link">
            <p>
              Bạn đã có tài khoản? <Link to="/login">Đăng nhập</Link>
            </p>{" "}
            {/* Link to register */}
          </div>
          <div className="homepage">
            <Link to="/">
              <FaHome />
            </Link>
          </div>
        </form>
      </div>
      {isLoading && (
        <div className="modal">
          <div className="overlay_loading">
            <div className="modal-content_loading">
              <div className="d-flex">
                <PacmanLoader color="#5e2e86" />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RegisterForm;
